import Component from '../Component';
import LayerControlButton from './LayerControlButton';
//import PrintButton from './PrintButton';

class ControlButtonGroupRight extends Component {
	constructor() {
		super();
		this.key = 'ctrl-btn-group-right';

		this.className = 'control-button-group--right';

		this.layerControlButton = new LayerControlButton();
//		this.printButton = new PrintButton();
	}

	componentDidMount() {
		this.layerControlButton.setRefs(this.refs);
		this.layerControlButton.componentDidMount();

//		this.printButton.setRefs(this.refs);
//		this.printButton.componentDidMount();
	}

	render() { 
		return `
            ${this.layerControlButton.render()}
        `; 
//			${this.printButton.render()}
//        `; 
	}
}

export default ControlButtonGroupRight;